import Unsplash from "unsplash-js";

const unsplash = new Unsplash({
  applicationId:
    "4ddee5a6dcd65455712a4bb90729e8122ac4666868e0fd3b7af6c9af50bb421d",
  secret: "5885f3fee5776efd39acee16dee6e8c242350fed04d304614f109596035c93ce"
});

export default unsplash;
